import { ReactComponent as GaanaColorLight } from 'fym-shared/src/music-services/assets/images/gaana-color-light.svg';
import { ReactComponent as GaanaColorDark } from 'fym-shared/src/music-services/assets/images/gaana-color-dark.svg';
import { ReactComponent as GaanaColorLightPadding } from 'fym-shared/src/music-services/assets/images/gaana-color-light-padding.svg';
import { ReactComponent as GaanaColorDarkPadding } from 'fym-shared/src/music-services/assets/images/gaana-color-dark-padding.svg';
import { MusicServiceImages } from './types';

export const gaanaImages: MusicServiceImages = {
  logoColor: {
    light: GaanaColorLight,
    dark: GaanaColorDark,
  },
  logoColorPadding: {
    light: GaanaColorLightPadding,
    dark: GaanaColorDarkPadding,
  },
};
